import settings from '@/settings'

let inserir = (data, headers) => {
  return fetch(`${settings.apetrusApi}/automacoes/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let list = (headers) => {
  return fetch(`${settings.apetrusApi}/automacoes/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let apagar = (headers, id) => {
  return fetch(`${settings.apetrusApi}/automacoes/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  inserir,
  list,
  apagar
}
